module.exports = __webpack_public_path__ + "img/part2-7.56f4323a.png";